import { GLOBAL_OBJ } from '@sentry/core';
var WINDOW = GLOBAL_OBJ;
export { WINDOW };